import { useEffect, useRef, useState } from 'react';
import VersionService, { keyVersion } from 'services/versionService';
import { showError } from 'helpers/handleError';
import { useSave } from 'redux/store/StoreCached';
import { detectBrowserHidden } from 'helpers';

const TIME_INTERVAL = 4000;

const useCheckVersion = () => {
  const interval = useRef(null);
  const save = useSave();
  const [isUserCanceled, setUserCanceled] = useState(false);
  const [shouldRunInterval, setShouldRunInterval] = useState(false);

  useEffect(() => {
    //* Init on load
    const checkOnLoad = async () => {
      try {
        const response = await VersionService.checkVersionFromServer();
        const nextVersion = response?.data;
        VersionService.setNewVersion(nextVersion);

        save(keyVersion, nextVersion);
        setShouldRunInterval(true);
      } catch (error) {
        showError(error);
      }
    };

    checkOnLoad();

    //* Init listener
    VersionService.broadCast().startListen();
  }, [save]);

  useEffect(() => {
    const fetch = async () => {
      try {
        const currentVersion = VersionService.getVersion();
        const { isHidden } = detectBrowserHidden();
        if (isHidden || isUserCanceled || !currentVersion) {
          return;
        }

        const response = await VersionService.checkVersionFromServer();
        const nextVersion = response?.data;

        if (currentVersion !== nextVersion) {
          const confirmReload = window.confirm(
            `Your version: ${currentVersion}.\nThe new version: ${nextVersion} has been released!\nDo you want to reload to get latest version? (Apply to all tabs opening)`
          );

          if (confirmReload) {
            window.location.reload();
            VersionService.broadCast().forceReload();
          } else {
            setUserCanceled(true);
          }
        }
      } catch (error) {
        showError(error);
      }
    };

    if (shouldRunInterval) {
      interval.current = setInterval(() => {
        fetch();
      }, TIME_INTERVAL);
    }

    return () => {
      clearInterval(interval.current);
    };
  }, [isUserCanceled, shouldRunInterval]);
};

export default useCheckVersion;
